import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import DeleteIcon from '@mui/icons-material/Delete';

import { useCallback, useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import DropBox from "../../custom/DropBox";
import ShowImage from "../../custom/ShowImage";
import { showDangerToast } from "../../constants/toaster";
import { s3 } from "../../constants/awsConfig";
import { WinnerPostionsComponent } from "./WinnerPostionsComponent";
const imageFileTypes = ["image/png", "image/gif", "image/jpeg"];
const otherFileTypes = [".arscene", ".videofx"];

export const AddEvent = (props) => {

  const [winnersList, setWinnersList] = useState([
    { position: '', totalViews: '', totalComments: '', totalLikes: '', prize: '' }
  ]);

  const handleChange = (index, field, value) => {
    const updatedList = [...winnersList];
    updatedList[index][field] = value;
    setWinnersList(updatedList);
  };

  const addWinner = () => {
    setWinnersList([
      ...winnersList,
      { position: '', totalViews: '', totalComments: '', totalLikes: '', prize: '' }
    ]);
  };

  const handleRemove = (index) => {
    if (winnersList.length === 1)
      alert("One Winner is require.")
    else {

      const updatedList = winnersList.filter((_, i) => i !== index);
      setWinnersList(updatedList);
    }
  };


  useEffect(() => {
    if (props?.eventFormData?.id) {
      if (props.bannerImage) {
        props.setThumbanailControl({
          showError: false,
          errorMessage: "",
          showImage: props?.eventFormData?.banner ? true : false,
          imageData: { src: props?.eventFormData?.banner },
        });
      }
      if (props?.eventFormData?.winnerCriteriaList) {
        setWinnersList(props?.eventFormData?.winnerCriteriaList)
      }
    } else {
      setWinnersList([])
    }
  }, [props.show]);
  const [value, setValue] = useState(dayjs());
  const [images, setImages] = useState([]);
  const [files, setFiles] = useState([]);

  const [startDate, setStartDate] = useState(new Date("2023-10-16T06:23:56"));
  const [endDate, setEndDate] = useState();
  const [startDateChanged, setStartDateChanged] = useState(false);


  const uploadFileToAWS = async (selectedFile) => {
    console.log(1);
    if (!selectedFile) return;
    console.log(2);

    const params = {
      Bucket: 'praxo-dev-cloud-front', // bucket name
      Key: `uploads/${selectedFile.name}`,
      Body: selectedFile,
      ContentType: selectedFile.type,
      // ACL: 'public-read', // Adjust according to your needs
    };

    try {
      const data = await s3.upload(params).promise();
      console.log('Upload Success', data.Location);
      const url = data.Location.replace(
        "https://praxo-dev-cloud-front.s3.ap-south-1.amazonaws.com/",
        "https://dhwdwg726vpm7.cloudfront.net/"
      );
      console.log(url, 'url');
      return { success: true, url: url }
    } catch (error) {
      console.error('Error uploading file:', error);
      return { success: false }
    }
  };


  const handleSubmit = async () => {
    if (props?.eventFormData?.id) {
      if (
        props?.eventFormData?.title &&
        props?.eventFormData?.description &&
        props?.eventFormData?.startDate &&
        props?.eventFormData?.endDate
      ) {
        if (props?.bannerImage) {
          const isImageUploaded = await uploadFileToAWS(props.bannerImage)
          if (isImageUploaded.success) {
            props.onSubmit(isImageUploaded.url, winnersList);
          } else {
            showDangerToast("Image upload failed.");
          }
        } else {
          if (props?.thumbanailControl.imageData?.src) {
            props.onSubmit(props?.thumbanailControl.imageData?.src, winnersList);
          } else {
            showDangerToast("Thumbnail is required.");
          }
        }
      } else {
        showDangerToast("Please fill all required Fields.");
      }
    } else {
      if (
        props?.eventFormData?.title &&
        props?.eventFormData?.description &&
        props?.eventFormData?.startDate &&
        props?.eventFormData?.endDate &&
        props?.bannerImage
      ) {
        const isImageUploaded = await uploadFileToAWS(props.bannerImage)
        if (isImageUploaded.success) {
          props.onSubmit(isImageUploaded.url, winnersList);
        } else {
          showDangerToast("Image upload failed.");
        }
      } else {
        showDangerToast("Please fill all required Fields.");
      }
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.map((file, index) => {
      if (imageFileTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onload = function (e) {
          setImages((prevState) => [
            ...prevState,
            { id: index, src: e.target.result },
          ]);
          props?.setBannerImage(file);
          props.setThumbanailControl({
            showError: false,
            errorMessage: "",
            showImage: true,
            imageData: { id: index, src: e.target.result },
          });
        };
        reader.readAsDataURL(file);

        return file;
      } else {
        props.setThumbanailControl({
          showError: true,
          errorMessage: "Only Image file is accept. ",
          showImage: false,
          imageData: [],
        });
      }
    });
  }, []);

  useEffect(() => {
    // console.log("propsssss", props);
    props.setThumbanailControl({
      showError: true,
      errorMessage: "",
      showImage: props?.eventFormData?.banner ? true : false,
      imageData: { src: props?.eventFormData?.banner },
    });
    props.setFilterFileControl({
      showError: true,
      errorMessage: "",
      showImage: true,
      imageData: { src: props?.eventFormData?.banner },
    });
  }, [props?.show === true]);

  const clickToRemove = () => {
    props?.setBannerImage(null)
  }

  // console.log("props?.thumbanailControl", props?.thumbanailControl);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.eventFormData?.id ? "Update Event" : "Add Event"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12">
            <Form.Control
              value={props.eventFormData?.title}
              onChange={(e) =>
                props.setEventFormData({
                  ...props?.eventFormData,
                  title: e.target.value,
                })
              }
              placeholder="Title"
              aria-label="Small"
              aria-describedby="inputGroup-sizing-sm"
            />
            {!props?.eventFormData?.title ? (
              <label className="custom-error-label">
                Title is required*
              </label>
            ) : (
              <></>
            )}
          </div>
          <div className="col-md-12">
            <Form.Control
              value={props.eventFormData?.description}
              onChange={(e) =>
                props.setEventFormData({
                  ...props?.eventFormData,
                  description: e.target.value,
                })
              }
              placeholder="Description"
              aria-label="Small"
              aria-describedby="inputGroup-sizing-sm"
            />
            {!props?.eventFormData?.description ? (
              <label className="custom-error-label">
                Description is required*
              </label>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6">
            Upload Thumbnail*
            <DropBox
              onDrop={onDrop}
              acceptType="image/*"
              isImage={true}
              thumbanailControl={props?.thumbanailControl}
              setThumbanailControl={props?.setThumbanailControl}
              clickToRemove={clickToRemove}
            />
            {props.thumbanailControl?.showError ? (
              <label className="custom-error-label" style={{ color: "red" }}>
                {" "}
                {props.thumbanailControl?.errorMessage}
              </label>
            ) : (
              <></>
            )}
            {props?.eventFormData?.id ? (
              <></>
            ) : props?.bannerImage === null ? (
              <label className="custom-error-label">
                Thumbnail is required*
              </label>
            ) : (
              <></>
            )}
          </div>
          <div className="col-md-6">
            Date Range*
            <div className="row col-md-12 mt-2">
              <DatePicker
                selected={props.eventFormData?.startDate}
                onChange={(date) => {
                  props?.setEventFormData({
                    ...props?.eventFormData,
                    startDate: date,
                  });
                  setStartDateChanged(true);
                  setStartDate(date);
                }}
                dateFormat="MM/dd/yyyy"
                minDate={new Date()}
                maxDate={props.eventFormData?.endDate ? props.eventFormData?.endDate : null}
              />
              {!props?.eventFormData?.startDate ? (
                <label className="custom-error-label">
                  Start Date is required*
                </label>
              ) : (
                <></>
              )}
            </div>
            <div className="row col-md-12 mt-4">
              <DatePicker
                selected={props.eventFormData?.endDate}
                onChange={(date) => {
                  props?.setEventFormData({
                    ...props?.eventFormData,
                    endDate: date,
                  });
                  setEndDate(date);
                }}
                dateFormat="MM/dd/yyyy"
                minDate={startDate}
                disabled={!startDateChanged}
              />
              {!props?.eventFormData?.endDate ? (
                <label className="custom-error-label">
                  End Date is required*
                </label>
              ) : (
                <></>
              )}
            </div>
            <div className="row col-md-12 mt-4">
              <Form.Control
                value={props.eventFormData?.basePrice}
                onChange={(e) =>
                  props.setEventFormData({
                    ...props?.eventFormData,
                    basePrice: e.target.value,
                  })
                }
                placeholder="Base Price"
                aria-label="Small"
                aria-describedby="inputGroup-sizing-sm"
              />
              {!props?.eventFormData?.basePrice ? (
                <label className="custom-error-label">
                  Base Price is required*
                </label>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="winners-modal">
              <h3>Winners List</h3>
              {winnersList.map((winnerData, index) => (
                <WinnerPostionsComponent
                  key={index}
                  index={index}
                  winnerData={winnerData}
                  handleChange={handleChange}
                  handleRemove={handleRemove}
                />
              ))}
              <div>

                <Button variant="outlined" style={{ textAlign: 'center' }} onClick={addWinner} startIcon={<DeleteIcon />}>
                  Add More
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outlined" onClick={props.onHide}>
          Cancel
        </Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};
